module.exports = __webpack_public_path__ + "img/0Q3B3199_L_WoodMatted.7302ecd8.jpg";